/* VIDEO TESTIMONIALS LIGHTBOX */

(function() {
  function pauseVideoMedia(videoMedia) {
    if (!videoMedia) return;
    if (typeof videoMedia.pause === 'function') {
      videoMedia.pause();
      return;
    }
    const video = videoMedia.querySelector('video');
    if (video) video.pause();
  }

  function playVideoMedia(videoMedia, options) {
    if (!videoMedia) return;
    const settings = options || {};
    const video = videoMedia.querySelector('video');
    if (video && settings.unmute) {
      video.muted = false;
    }
    if (typeof videoMedia.play === 'function') {
      videoMedia.play({ restart: settings.restart !== false });
      return;
    }
    if (video) {
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function() {});
      }
    }
  }

  class VideoTestimonialLightbox {
    constructor(root) {
      this.root = root;
      this.lightbox = root.querySelector('.bk-media-vt-lightbox');
      this.track = this.lightbox ? this.lightbox.querySelector('.bk-media-vt-lightbox__track') : null;
      this.header = this.lightbox ? this.lightbox.querySelector('.bk-media-vt-lightbox__header') : null;
      this.prevBtn = this.lightbox ? this.lightbox.querySelector('[data-vt-prev]') : null;
      this.nextBtn = this.lightbox ? this.lightbox.querySelector('[data-vt-next]') : null;
      this.feedPreviews = Array.from(root.querySelectorAll('.bk-media-vt__preview video-media[autoplay]'));

      if (!this.lightbox || !this.track) {
        this.initialized = false;
        return;
      }

      this.slides = Array.from(this.track.querySelectorAll('.bk-media-vt-lightbox__slide'));
      this.currentIndex = 0;
      this.isOpen = false;
      this.scrollRaf = null;
      this.initialized = true;
      this.mountLightbox();
      this.bind();
    }

    mountLightbox() {
      const lightboxId = this.lightbox.id;
      if (lightboxId) {
        const duplicate = document.getElementById(lightboxId);
        if (duplicate && duplicate !== this.lightbox) {
          duplicate.remove();
        }
      }

      if (this.lightbox.parentElement !== document.body) {
        document.body.appendChild(this.lightbox);
      }
    }

    bind() {
      const self = this;

      this.root.addEventListener('click', function(event) {
        const trigger = event.target.closest('[data-vt-open]');
        if (!trigger || !self.root.contains(trigger)) return;
        event.preventDefault();
        event.stopPropagation();
        const index = parseInt(trigger.getAttribute('data-vt-index'), 10);
        if (!Number.isNaN(index)) {
          self.open(index);
        }
      });

      this.lightbox.querySelectorAll('[data-vt-close]').forEach(function(button) {
        button.addEventListener('click', function(event) {
          event.preventDefault();
          event.stopPropagation();
          self.close();
        });
      });

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', function(event) {
          event.preventDefault();
          event.stopPropagation();
          self.goTo(self.currentIndex - 1);
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', function(event) {
          event.preventDefault();
          event.stopPropagation();
          self.goTo(self.currentIndex + 1);
        });
      }

      this.track.addEventListener('scroll', function() {
        if (!self.isOpen) return;
        if (self.scrollRaf) return;
        self.scrollRaf = requestAnimationFrame(function() {
          self.scrollRaf = null;
          const index = self.getIndexFromScroll();
          if (index !== self.currentIndex) {
            self.currentIndex = index;
            self.syncSlide(index);
          }
        });
      }, { passive: true });

      document.addEventListener('keydown', function(event) {
        if (!self.isOpen) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          self.close();
        } else if (event.key === 'ArrowLeft') {
          event.preventDefault();
          self.goTo(self.currentIndex - 1);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          self.goTo(self.currentIndex + 1);
        }
      });
    }

    getIndexFromScroll() {
      const scrollLeft = this.track.scrollLeft;
      let closestIndex = 0;
      let closestDistance = Infinity;

      this.slides.forEach(function(slide, index) {
        const distance = Math.abs(slide.offsetLeft - scrollLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    }

    open(index) {
      if (!this.slides.length) return;

      const slideIndex = Math.max(0, Math.min(index, this.slides.length - 1));
      this.mountLightbox();
      this.pauseFeedPreviews();
      this.isOpen = true;
      this.currentIndex = slideIndex;

      this.lightbox.hidden = false;
      this.lightbox.setAttribute('data-open', 'true');
      document.body.classList.add('bk-media-vt-lightbox-open');
      document.body.style.overflow = 'hidden';

      this.goTo(slideIndex, false);
      this.syncSlide(slideIndex);
    }

    close() {
      if (!this.isOpen) return;

      this.isOpen = false;
      this.pauseAllSlides();
      this.lightbox.setAttribute('data-open', 'false');
      this.lightbox.hidden = true;
      document.body.classList.remove('bk-media-vt-lightbox-open');
      document.body.style.overflow = '';
      this.resumeFeedPreviews();
    }

    goTo(index, smooth) {
      if (index < 0 || index >= this.slides.length) return;

      const slide = this.slides[index];
      const shouldSmooth = smooth !== false;

      this.track.scrollTo({
        left: slide.offsetLeft,
        behavior: shouldSmooth ? 'smooth' : 'auto'
      });

      this.currentIndex = index;
      this.syncSlide(index);
    }

    syncSlide(index) {
      this.slides.forEach(function(slide, slideIndex) {
        const videoMedia = slide.querySelector('video-media');
        if (slideIndex === index) {
          playVideoMedia(videoMedia, { restart: true, unmute: true });
        } else {
          pauseVideoMedia(videoMedia);
        }
      });

      this.updateHeader(index);
      this.updateNav(index);
    }

    updateHeader(index) {
      if (!this.header) return;

      const slide = this.slides[index];
      if (!slide) return;

      const title = slide.getAttribute('data-vt-title') || '';
      const profile = slide.getAttribute('data-vt-profile') || '';
      const titleEl = this.header.querySelector('.bk-media-vt-lightbox__title-text');
      const profileEl = this.header.querySelector('.bk-media-vt-lightbox__profile-image');
      const profileWrap = this.header.querySelector('.bk-media-vt-lightbox__profile');

      if (titleEl) {
        titleEl.textContent = title;
      }

      if (profileEl && profileWrap) {
        if (profile) {
          profileEl.src = profile;
          profileWrap.hidden = false;
        } else {
          profileWrap.hidden = true;
        }
      }

      this.header.hidden = !title && !profile;
    }

    updateNav(index) {
      if (this.prevBtn) {
        this.prevBtn.disabled = index <= 0;
      }
      if (this.nextBtn) {
        this.nextBtn.disabled = index >= this.slides.length - 1;
      }
    }

    pauseFeedPreviews() {
      this.feedPreviews.forEach(pauseVideoMedia);
    }

    resumeFeedPreviews() {
      this.feedPreviews.forEach(function(videoMedia) {
        const video = videoMedia.querySelector('video');
        if (video) {
          video.muted = true;
        }
        playVideoMedia(videoMedia, { restart: false, unmute: false });
      });
    }

    pauseAllSlides() {
      this.slides.forEach(function(slide) {
        pauseVideoMedia(slide.querySelector('video-media'));
      });
    }
  }

  function initBlock(root) {
    const instanceId = root.getAttribute('data-vt-instance');
    if (!instanceId) return null;

    const instance = new VideoTestimonialLightbox(root);
    if (instance.initialized) {
      window.BkMediaVideoTestimonials.instances[instanceId] = instance;
      return instance;
    }

    return null;
  }

  function initAll() {
    document.querySelectorAll('[data-vt-instance]').forEach(function(root) {
      const instanceId = root.getAttribute('data-vt-instance');
      const existing = window.BkMediaVideoTestimonials.instances[instanceId];
      if (existing && existing.root !== root) {
        delete window.BkMediaVideoTestimonials.instances[instanceId];
      }
      if (existing && existing.root === root && existing.initialized) {
        return;
      }
      initBlock(root);
    });
  }

  window.BkMediaVideoTestimonials = {
    instances: {},
    initAll: initAll,
    initBlock: initBlock
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function() {
    window.BkMediaVideoTestimonials.instances = {};
    setTimeout(initAll, 100);
  });

  document.addEventListener('product:rerender', function() {
    window.BkMediaVideoTestimonials.instances = {};
    setTimeout(initAll, 100);
  });
})();

/* VIDEO TESTIMONIALS LIGHTBOX */
